"use client";

import React from "react";
import PropTypes from "prop-types";
import {
   MediaAgeVerificationFrame as AgeVerificationFrame,
} from 'common/components/modules/media';
import ImgGallery from 'common/components/modules/img-gallery'
const StoreMediaContent = ({
   data,
   isAgeVerificationRequired,
}) => {
   const posterIsSfw = !data?.thumbnail_is_sfw && isAgeVerificationRequired;

   let newImgArray = []
   if(!!data && !!data.image_full_src){
      newImgArray = [...JSON.parse((data && data?.image_full_src) && data?.image_full_src)]
   }

   const images = newImgArray?.map(item => {
      return { original: item,
         thumbnail: item,
      }
   })
   return (
      <>
         <ImgGallery
            images={ images }
            showFullScreen={ false }
            classNameIconDiv='next-icon-classes z-40 mms-media-button-wrapper-bg'
            isLockedForSFW={ posterIsSfw }
            showBullets
            isPreventFullScreenAction
         />
         {
            posterIsSfw && (
               <AgeVerificationFrame
                  className='cover_image_wrapper_hover_element hidden z-10'
                  onClickVerifyAgeButton={ _ => {} }
               />
            )
         }
      </>
   )
}

StoreMediaContent.propTypes = {
   data: PropTypes.object,
   isAgeVerificationRequired: PropTypes.bool,
};

export default StoreMediaContent;
